// src/hooks/paxTypes/useUpdatePaxType.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updatePaxType } from "../../api/apiPaxTypes";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useUpdatePaxType = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: updatePaxTypes, isPending: isUpdate } = useMutation({
        mutationFn: ({ id, req }) => updatePaxType(req, id),
        onSuccess: (res) => {
            const message = res?.message || "Pax type updated successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["paxTypes"] });
            queryClient.invalidateQueries({ queryKey: ["paxType"] });
            navigate("/pax-types");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to update pax type");
        },
    });

    return { updatePaxTypes, isUpdate };
};

export default useUpdatePaxType;